import React, { useEffect} from "react";
import { Link } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";

export const Login = () => {

  useEffect(() => {
    document.title = 'Login'; // Set the title to "Login" when this component mounts
  }, []);
  return (
    <section className="login">
      <div className="container py-5">
        <div className="row py-5">
          <div className="col-lg-6" data-aos="fade-right" data-aos-duration="1000">
            <div className="login-left">
              <div className="text-center mb-4">
                <h3 className="f-24 fw-700">Login</h3>
              </div>
              <div className="login-form mt-5">
                <Form>
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>Email address</Form.Label>
                    <Form.Control type="email" placeholder="Enter Email" />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formBasicPassword">
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Enter Password"
                    />
                  </Form.Group>

                  <Button type="login" className="w-100 login-btn">
                    LOGIN
                  </Button>
                  <div className="mt-2">
                    <Link to="/forgotpassword">Lost your password?</Link>
                  </div>
                </Form>
              </div>
            </div>
          </div>

          <div className="col-lg-6 ps-lg-5" data-aos="fade-left" data-aos-duration="1000">
            <div className="login-right pt-5 pt-lg-0">
              <div className="text-center mb-5">
                <h3 className="f-24 fw-700">New Customer</h3>
              </div>
              <div className="sign-up mt-5">
                <h4 className="f-18 fw-600">Create Account</h4>
                <p>
                  Sign up for a free account at our store. Registration is quick
                  and easy. It allows you to be able to order from our shop. To
                  start shopping click register.
                </p>
                <Link to="/signup" className="btn-1">
                  CREATE ACCOUNT
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};